module.exports = __webpack_public_path__ + "static/media/Level2.ea46b38b.png";